import { useCallback, useEffect, useState } from 'react';
import { useFiltersBarContext } from '../state/FiltersBarContext';
import { useFiltersBarLayoutManagerContext } from '../state/FiltersBarLayoutManagerContext';
export const useQuickFilterOpenState = propertyName => {
  const {
    enableAutoOpenInputPopovers,
    newestCustomPropertyName
  } = useFiltersBarContext();
  const {
    isLayoutManager
  } = useFiltersBarLayoutManagerContext();
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (enableAutoOpenInputPopovers && newestCustomPropertyName === propertyName && !isLayoutManager) {
      setTimeout(() => {
        setIsOpen(true);
      }, 200);
    }
  }, [enableAutoOpenInputPopovers, newestCustomPropertyName, propertyName, isLayoutManager]);
  const onToggleOpen = useCallback(() => {
    setIsOpen(currentIsOpen => !currentIsOpen);
  }, []);
  return {
    isOpen,
    onToggleOpen
  };
};